<script>
export default {
  name: 'MaterialInputDual',
  props: {
    label: {
      type: String,
    },
    error: {
      default: null,
    },
    hint: {
      default: null,
    },
  },
}
</script>

<template>
  <div class="md-input-dual">
    <md-field :class="{ 'md-invalid': error }">
      <label>{{ label }}</label>
      <slot name="left"></slot>
      <slot name="right"></slot>
      <span v-if="hint" class="md-helper-text">{{ hint }}</span>
      <span class="md-error">{{ error }}</span>
    </md-field>
  </div>
</template>

<style>
  .md-input-dual .md-checkbox {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Material/MaterialInputDual.vue